
<section class="FAQSection" :class="{ 'is-light': theme === 'light' }">
    <div class="container">
        <div class="SectionHeader">
            <h2>{{ title }}</h2>
            <p>{{ subtitle }}</p>
        </div>

        <div class="FAQList">
            <div
                v-for="(faq, index) in faqs"
                :key="index"
                class="FAQItem"
                :class="{ 'is-open': openItems.includes(index) }"
            >
                <button
                    class="FAQQuestion"
                    @click="toggleFAQ(index)"
                    :aria-expanded="openItems.includes(index)"
                    :aria-controls="`faq-answer-${index}`"
                >
                    <span class="QuestionText">{{ faq.question }}</span>
                    <i
                        class="ri-arrow-down-s-line FAQIcon"
                        :class="{ 'is-rotated': openItems.includes(index) }"
                    ></i>
                </button>

                <div
                    class="FAQAnswer"
                    :id="`faq-answer-${index}`"
                    :aria-hidden="!openItems.includes(index)"
                >
                    <div class="AnswerContent" v-html="faq.answer"></div>

                    <!-- CTA for specific questions -->
                    <div v-if="faq.showCTA" class="FAQCTA">
                        <router-link
                            :to="
                                faq.ctaLink ||
                                (showPromotion
                                    ? '/register?promotion=true&source=faq'
                                    : '/register?source=faq')
                            "
                        >
                            <SiteButton>
                                {{
                                    faq.ctaText ||
                                    (showPromotion
                                        ? 'Jetzt 50% Rabatt sichern'
                                        : 'Jetzt registrieren')
                                }}
                            </SiteButton>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <!-- Additional Trust Elements -->
        <div class="FAQFooter">
            <div class="StillHaveQuestions">
                <h3>Noch Fragen?</h3>
                <p>Kontaktieren Sie uns für individuelle Beratung</p>
                <a
                    :href="
                        contactHref ||
                        'mailto:support@taxifusion.de?subject=Frage%20zur%20TaxiFusion'
                    "
                    class="ContactLink"
                >
                    <SiteButton variant="outline">
                        <i class="ri-mail-line"></i>
                        {{ contactText || 'support@taxifusion.de' }}
                    </SiteButton>
                </a>
            </div>
        </div>
    </div>
</section>
